import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
    DetailViewModule,
} from '@ui/shared/ui-detail-view';
import type { PreventionListItemModel } from '../definitions/prevention-list-item.model';
import { PreventionDetailsHeaderComponent } from './prevention-details-header.component';
import { PreventionDetailsContactComponent } from './prevention-details-contact.component';
import { PreventionDetailsAudienceComponent } from './prevention-details-audience.component';
import { PreventionDetailsContentComponent } from './prevention-details-content.component';
import { PreventionDetailsFrameworkComponent } from './prevention-details-framework.component';

@Component({
    selector: 'ui-prevention-list-item-details',
    imports: [
        DetailViewModule,
        PreventionDetailsHeaderComponent,
        PreventionDetailsContactComponent,
        PreventionDetailsAudienceComponent,
        PreventionDetailsContentComponent,
        PreventionDetailsFrameworkComponent,
    ],
    templateUrl: './prevention-list-item-details.component.html',
    styleUrl: './prevention-list-item-details.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreventionListItemDetailsComponent {
    public mapItem = input.required<PreventionListItemModel>();
}
